import * as firebase from '@/firebase';

const { storage } = firebase;

export default class StorageService {
  static async getDownloadPathFromChild(path) {
    return storage.child(path).getDownloadURL();
  }

  static async getDownloadPathFromURL(url) {
    return storage.refFromURL(url).getDownloadURL();
  }

  static async getBlobFromURL(url) {
    let blob;
    const path = await StorageService.getDownloadPathFromURL(url);

    await fetch(path)
      .then((response) => response.blob())
      .then((file) => { blob = file; });

    return blob;
  }
}
